import _asyncToGenerator from "/opt/github/_work/frontend-website-cms/frontend-website-cms/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/opt/github/_work/frontend-website-cms/frontend-website-cms/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/opt/github/_work/frontend-website-cms/frontend-website-cms/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _createForOfIteratorHelper from "/opt/github/_work/frontend-website-cms/frontend-website-cms/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _regeneratorRuntime from "/opt/github/_work/frontend-website-cms/frontend-website-cms/node_modules/@babel/runtime/regenerator/index.js";

/* eslint-disable */
import $ from "cash-dom";
import { findKey } from "lodash";
import queryString from "query-string";
import { getFipsCodeByState, stateToFips } from "./chartModifiers";
import { ChartModel, Chart } from "@usafacts/frontend-library-metrics/dist/usafacts-metrics";
import { copy } from "./sharing";
import ChartExplorerModel from "@usafacts/frontend-library-explorer/dist/ChartExplorerModel";
import MetricTree from "@usafacts/frontend-library-explorer/dist/MetricTree";
import "@usafacts/frontend-library-explorer/dist/MetricTree.css";
import ChartTypeSelector from "@usafacts/frontend-library-explorer/dist/ChartTypeSelector";
import "@usafacts/frontend-library-explorer/dist/ChartTypeSelector.css";
var query = queryString.parse(location.search);
var defaultParameters = {
  defaultToOverlapYears: true,
  transition: true,
  transitionDuration: 500,
  uncollapsible: true
};

function getChildMetrics(metric, array) {
  if (metric.children) {
    var _iterator = _createForOfIteratorHelper(metric.children),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var child = _step.value;
        array.push(child);
        getChildMetrics(child, array);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
}

function flattenChildMetrics(model) {
  var tree = model.metricTree;
  var children = tree.children;
  var metrics = [model.metricTree];

  var _iterator2 = _createForOfIteratorHelper(children),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var child = _step2.value;
      getChildMetrics(child, metrics);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return metrics;
}

export function initChartExplorerAdjustments(model, modelState) {
  var picker = $("#chart-explorer__adjustments-picker");
  var state = modelState;
  var availableAdjustments = model.metricTree.availableadjustments; // Show the adjustments panel

  if (availableAdjustments.length > 0) {
    $(picker).removeAttr("hidden");
  } // Disable any adjustments that can't be applied due to child metrics


  var allChildMetrics = flattenChildMetrics(model);
  var selectedChildMetrics = [];

  var _iterator3 = _createForOfIteratorHelper(model.metrics),
      _step3;

  try {
    var _loop = function _loop() {
      var selectedMetric = _step3.value;
      var childMetric = allChildMetrics.find(function (m) {
        return m.id == selectedMetric;
      });
      selectedChildMetrics.push(childMetric);
    };

    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  if ($("#chart-explorer__adjustments-picker .metric__adjustments").children().length == 0) {
    var _iterator4 = _createForOfIteratorHelper(availableAdjustments),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var adjustment = _step4.value;
        var metricSlug = adjustment.shortlabel.split(" ").join("");

        if (metricSlug === "null") {
          metricSlug = "";
        }

        $(picker).find(".metric__adjustments").append("\n        <label class=\"w-1/2 md:w-full block flex items-center mb-2 text-sm\">\n          <input class=\"form-checkbox flex-shrink-0 text-usafacts-blue text-xl mr-2 border-2 border-gray-400\" type=\"radio\" name=\"adjustment\" tabindex=\"0\" data-adjustment=\"".concat(metricSlug, "\"").concat(model.adjustment == metricSlug ? " checked" : "", " />\n          <span>").concat(adjustment.name, "</span>\n        </label>\n      "));
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }

    $(picker).find("input").on("click", function (event) {
      var element = $(event.target);
      var adjustment = $(event.target).attr("data-adjustment");
      if (adjustment === "null") adjustment = "";
      $("#chart-explorer .dh-chart-wrapper .chart-loading").css("display", "flex");
      $("#chart-explorer .dh-chart-wrapper .chart-loading").css("background", "rgba(255,255,255,.75)");

      if (model.adjustment == adjustment) {
        $(event.target).prop("checked", false);
        model.setAdjustment("");
      } else {
        model.setAdjustment(adjustment);
      }
    });
    $("#chart-explorer__types .dha-select-multiple").on("click", function () {
      // 'reset all selections' button click
      $(".metric__adjustments .form-checkbox").prop("checked", false);
      model.setAdjustment("");
    });
  } // If there exists an adjustment that can't be applied


  var _iterator5 = _createForOfIteratorHelper(availableAdjustments),
      _step5;

  try {
    var _loop2 = function _loop2() {
      var adj = _step5.value;
      var adjustment = adj.shortlabel.split(" ").join("");
      if (adjustment === "null") adjustment = "";

      if (selectedChildMetrics.every(function (x) {
        if (!x) {
          return true;
        }

        var adjustmentIn = x.availableadjustments.find(function (y) {
          return y.shortlabel == adj.shortlabel;
        });

        if (typeof adjustmentIn !== "undefined") {
          return true;
        } else {
          return false;
        }
      })) {
        $("#chart-explorer__adjustments-picker [data-adjustment=\"".concat(adjustment, "\"]")).removeAttr("disabled");
      } else {
        $("#chart-explorer__adjustments-picker [data-adjustment=\"".concat(adjustment, "\"]")).attr("disabled", true);
      }
    };

    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      _loop2();
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }
}
export function initChartExplorerStatePicker(model, modelState) {
  var picker = $("#chart-explorer__state-picker");
  var stateElements = $(picker).find("path");
  var toggleContainer = $(picker).find(".chart-explorer__state");
  var toggleHeading = $(picker).find(".metric__box-header");

  if (modelState.hasStates) {
    $(picker).css("display", "block");
    $(picker).removeAttr("disabled");
  } else {
    $(picker).attr("disabled", true);
  }

  $(toggleHeading).off("click");
  $(toggleHeading).on("click", function () {
    $(picker).toggleClass("active");
  });
  $("#chart-explorer__state-picker__select-multiple").off("click");
  $("#chart-explorer__state-picker__select-multiple").on("click", function (event) {
    model.setCompareMode("states");
    $("#chart-explorer__state-picker__select-all").show();
  });
  $("#chart-explorer__state-picker__select-all").off("click");
  $("#chart-explorer__state-picker__select-all").on("click", function (event) {
    if (modelState.states.length < 51) {
      // All states, excluding 'usa'
      var states = _objectSpread({}, stateToFips);

      delete states.usa;
      var allStates = Object.values(states);
      model.setStates(allStates);
      $(this).text("deselect all");
      return false;
    } else {
      model.setStates(["00"]);
      $(this).text("select all");
      return false;
    }
  });
  $(stateElements).off("mouseenter");
  $("#chart-explorer__state-picker .metric__state-picker-svg path").on("mouseenter", function (event) {
    var chosenState = $(this).attr("data-state");
    var stateCode = getFipsCodeByState(chosenState.split("-").join(" "));
    model.setHighlightState(stateCode);
  });
  $(stateElements).off("mouseleave");
  $("#chart-explorer__state-picker .metric__state-picker-svg path").on("mouseleave", function (event) {
    model.setHighlightState();
  });
  $(stateElements).off("click");
  $(stateElements).on("click", function (event) {
    var chosenState = $(this).attr("data-state");
    var stateCode = getFipsCodeByState(chosenState.split("-").join(" "));
    $("#chart-explorer .dh-chart-wrapper .chart-loading").css("display", "flex");
    $("#chart-explorer .dh-chart-wrapper .chart-loading").css("background", "rgba(255,255,255,.75)");
    model.toggleState(stateCode); // Remove US from active states

    var activeStates = modelState.states;
    var index = activeStates.indexOf("00");

    if (index !== -1) {
      activeStates.splice(index, 1);
    }

    var currentStateIndex = activeStates.indexOf(stateCode);

    if (currentStateIndex !== -1 && activeStates.length <= 51) {
      // Deselecting state
      $("#chart-explorer__state-picker__select-all").text("select all");
    } else if (currentStateIndex == -1 && activeStates.length == 50) {
      // Selecting state
      $("#chart-explorer__state-picker__select-all").text("deselect all");
    }

    return false;
  });
}
export function initChartExplorerSharing(model, modelState) {
  modelState.chartOptions.metrics = JSON.stringify(modelState.chartOptions.metrics);

  function getShareUrl() {
    var options = $("#chart-explorer").attr("data-options");
    var qs = encodeURI(options);
    return "".concat(window.location.origin).concat(window.location.pathname, "?metric=").concat(model.metricTree.id, "&explore=").concat(qs, "#explorer");
  } // Remove default parameters


  for (var _i = 0, _Object$keys = Object.keys(defaultParameters); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    delete modelState.chartOptions[key];
  }

  $("#chart-explorer").attr("data-options", JSON.stringify(modelState.chartOptions));
  var twitterLink = $("#chart-explorer").parent().find(".chart-explorer-share-icons__twitter");
  var facebookLink = $("#chart-explorer").parent().find(".chart-explorer-share-icons__facebook");
  var linkedinLink = $("#chart-explorer").parent().find(".chart-explorer-share-icons__linkedin");
  var mailLink = $("#chart-explorer").parent().find(".chart-explorer-share-icons__mail");
  var printLink = $("#chart-explorer").parent().find(".chart-explorer-share-icons__print");
  var embedLink = $("#chart-explorer").parent().find(".chart-explorer-share-icons__embed");
  facebookLink.off();
  facebookLink.on("click keypress", function (e) {
    if (e.which === 1 || e.which === 13) {
      var url = getShareUrl();
      window.open("https://www.facebook.com/dialog/share?app_id=444773196460067&display=popup&href=" + encodeURIComponent(url), "_blank", "height=570,width=520");
    }
  });
  twitterLink.off();
  twitterLink.on("click keypress", function (e) {
    if (e.which === 1 || e.which === 13) {
      var url = getShareUrl();
      window.open("https://twitter.com/intent/tweet?url=" + encodeURIComponent(url) + "&text=" + encodeURIComponent("Exploring ".concat(modelState.metricTree.name)) + "&via=USAFacts", "_blank", "height=570,width=520");
    }
  });
  linkedinLink.off();
  linkedinLink.on("click keypress", function (e) {
    if (e.which === 1 || e.which === 13) {
      var url = getShareUrl();
      window.open("https://www.linkedin.com/shareArticle?url=" + encodeURIComponent(url) + "&title=" + encodeURIComponent("Exploring ".concat(modelState.metricTree.name)), "_blank", "height=570,width=520");
    }
  });
  mailLink.off();
  mailLink.on("click keypress", function (e) {
    e.preventDefault();

    if (e.which === 1 || e.which === 13) {
      var url = getShareUrl();
      window.open("mailto:?subject=" + encodeURIComponent(document.title) + "&body=" + encodeURIComponent(url), "_blank", "height=570,width=520");
    }
  });
  printLink.off();
  printLink.on("click keypress", function (e) {
    if (e.which === 1 || e.which === 13) {
      e.preventDefault();
      window.print();
      return false;
    }
  });
  embedLink.off();
  embedLink.on("click keypress", function (e) {
    if (e.which === 1 || e.which === 13) {
      var container = $("#chart-explorer").parent();
      var url = $(e.target).attr("data-url");
      var options = $(container).find("#chart-explorer").attr("data-options");
      var qs = JSON.parse(options || "{}");

      var isNull = function isNull(value) {
        return value === null || "".concat(value) === "null";
      };

      var filteredQs = Object.keys(qs).reduce(function (acc, key) {
        return isNull(qs[key]) || qs[key] === {} || qs[key] === [] || qs[key] === "[]" ? acc : _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, qs[key]));
      }, {}); // stringify nested array of objects

      Object.keys(filteredQs).forEach(function (key) {
        if (typeof filteredQs[key] === "object") {
          filteredQs[key] = JSON.stringify(filteredQs[key]);
        }
      }); // Re-add default parameters only for embed

      qs = _objectSpread(_objectSpread({}, filteredQs), defaultParameters);
      var fullUrl = "".concat(url, "?").concat(queryString.stringify(qs), "#explorer"); // trackShare('chart', 'embed', fullUrl);

      var modal = $(container).find(".chart-share-modal");
      var input = $(modal).find(".chart-share-modal__url");
      input.html("<iframe width=\"750\" height=\"520\" frameborder=\"0\" src=\"".concat(window.location.origin).concat(fullUrl, "\"></iframe>"));
      $(".chart-share-modal").removeClass("active");
      $(modal).find(".chart-share-modal__body").get(0).focus();
      $(modal).toggleClass("active");
      var button = $(modal).find(".chart-share-modal__button");
      button.on("click keypress", function (ev) {
        var code = ev.keyCode || ev.which;

        if (code === 1 || code === 13) {
          ev.preventDefault();
          var el = input.get(0);
          copy(el);
          $(el).next().text("Copied!");
          setTimeout(function () {
            $(el).next().text("Copy");
          }, 2000);
        }
      });
    }
  });
}
export default function initChartExplorer() {
  if ($("#chart-explorer").length > 0) {
    var chart = new Chart($("#chart-explorer")[0]);

    var _query = queryString.parse(location.search);

    var metric = $("#chart-explorer").attr("data-metric");
    var options = {};
    var states = []; // Manually set states, can't pass in as options.

    if (_query && Object.keys(_query).length > 1) {
      options = _query.explore ? JSON.parse(_query.explore) : {};

      if (options.metrics) {
        options.metrics = JSON.parse(options.metrics).map(function (m) {
          // All metrics will have the same states.
          if (m.states && states.length === 0) {
            states = m.states.map(function (s) {
              return s.fips;
            });
          }

          return m.id;
        });
      } else {
        options.metrics = [metric];
      } // Adds object properties.


      options = JSON.parse(JSON.stringify(options));
    } // Add in default parameters


    options = _objectSpread(_objectSpread({}, options), defaultParameters);

    function checkDuplicates(arr) {
      return new Set(arr).size !== arr.length;
    }

    if (options.metrics && checkDuplicates(options.metrics)) {
      // If duplicate metrics exist that means that both 'USA' and a state is
      // selected. 'USA' is handled as an extra metric without FIPS defined.
      states.push("00");
    }

    var chartModel = new ChartModel();
    var model = new ChartExplorerModel(options);

    if (states.length > 0) {
      model.setCompareMode("states");
      model.setStates(states);
    }

    new MetricTree($("#chart-explorer__tree")[0], model);
    new ChartTypeSelector($("#chart-explorer__types")[0], model); // We want to redraw chart when anything changes

    model.registerCallback(function (_ref) {
      var chartOptions = _ref.chartOptions;
      chart.draw(chartModel.getChartData(chartOptions), chartOptions);
      var modelState = model.getModelState(); // Show or hide the multiple state selector option

      if (modelState.compareMode == "metrics") {
        $("#chart-explorer__state-picker__select-multiple").show();
        $("#chart-explorer__state-picker__select-all").hide();
      } else {
        $("#chart-explorer__state-picker__select-multiple").hide();
      } // Remove all states


      $("#chart-explorer__state-picker [data-state]").removeClass("active"); // Set active states from model options

      var _iterator6 = _createForOfIteratorHelper(modelState.states),
          _step6;

      try {
        var _loop3 = function _loop3() {
          var item = _step6.value;
          var key = findKey(stateToFips, function (st) {
            return st == item;
          });
          $("#chart-explorer__state-picker [data-state='".concat(key, "']")).addClass("active");
        };

        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          _loop3();
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      initChartExplorerAdjustments(model, modelState);
      initChartExplorerSharing(model, modelState);
      initChartExplorerStatePicker(model, modelState);
      $("#chart-explorer").parent().find(".chart-explorer-share-icons__download").off();
      $("#chart-explorer").parent().find(".chart-explorer-share-icons__download").on("click keypress", /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
          var canvas, image;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  e.preventDefault();
                  _context.next = 3;
                  return chart.drawCanvas(chartModel.getChartData(chartOptions), chartOptions);

                case 3:
                  canvas = _context.sent;
                  image = canvas.toDataURL("image/png");
                  $(this).attr("href", image);
                  $(this)[0].click();
                  $(this).off();

                case 8:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    }); // Set a root metric

    model.setRoot(metric);
  }
}